module.exports = __webpack_public_path__ + "29c9e0c54a0d641d1cfe0579538a2942.svg";